import { render, staticRenderFns } from "./DriverPerks.vue?vue&type=template&id=3ad397fa&"
import script from "./DriverPerks.vue?vue&type=script&lang=js&"
export * from "./DriverPerks.vue?vue&type=script&lang=js&"
import style0 from "./DriverPerks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports